/* Info Component on the Day component */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../../styles/Callsheets.module.css";
import { useCurrentUser } from "../../../contexts/CurrentUserContext";

const InfoStrip = ({callsheet}) => {
    const currentUser = useCurrentUser();
    const projectType = currentUser?.project_category_type
    ? JSON.parse(currentUser?.project_category_type)
    : null;

  return (
    <div>
        <Row className='my-3'>
            <Col className={`px-3 pt-1 ${styles.SubTitle6 }`} md={{span: 10, offset: 1 }}>
            <p className={`${styles.Red} text-center`}>2ND UNIT - SCHEDULE INFO</p>
            <hr className={`mt-2 mb-0`}/>
            <p className='pt-2'>
            <span className={`${styles.Red}`}>*</span> Add Scenes to the Stripboard by clicking the <span className={`${styles.Red}`}>Add Scene</span> tab.
            </p>
            <p className='pt-2'><span className={`${styles.Red}`}>*</span> Enter the Scene Shoot information in the Add Scene form
            that opens below.
              </p>
              <p className='pt-2'><span className={`${styles.Red}`}>*</span> Important!<span className={`${styles.Red}`}> MOVES and MEAL BREAKS </span>
                 are added to whichever Scene they immediately 
                follow in the Scene's <span className={`${styles.Red}`}>NEXT</span> field.
                </p>
              <p className='pt-2'><span className={`${styles.Red}`}>*</span> The Stripboard's <span className={`${styles.Red}`}>Locations</span> will automatially display 
                in the Callsheet's Locations section.
              </p>
              <p className='pt-2'><span className={`${styles.Red}`}>*</span> The Primary Nearest <span className={`${styles.Red}`}>Hospital</span> is added on the Callsheet
               but a Location's Nearest Hospital can be in the Parking/Directions/Notes field also.
              </p>
              <p className={`pt-1`}>
                <span className={`${styles.Red}`}>*</span> If a Scene is to be <span className={`${styles.Red}`}>deleted</span> move it to the 
              last Day Order position first to keep the automatic ordering correct.
              </p>
              {callsheet.results.length ? ("") : (
                <p className='pt-2'>
            <span className={`${styles.Red}`}>*</span> Click the Create Callsheet tab to Create the Shoot Days Callsheet.
            </p>
              )}
              <p className={`pt-1`}>
              <span className={`${styles.Red}`}>*</span> Users who are assigned to work on the 2nd Unit Schedule need to be given 
              the <span className={`${styles.Red}`}>Admin or Superadmin</span> Permission.
              </p>
              <p className={`${styles.Small} pt-3`}>
              <span className={`${styles.Red}`}>*</span> Important! Admins and Superadmins not assigned to work on the Schedule should not use the 
              Drag and Drop or delete Scenes.
              </p>
              <hr className={`mt-2 mb-0`}/>
            </Col>
        </Row>
    </div>
  )
}

export default InfoStrip